export const renumberRegisterVehicleTabs: IRenumberRegisterVehicleTabs = {
  series: 'Series',
  singleVehicle: 'Single Vehicle',
};
  
export interface IRenumberRegisterVehicleTabs {
    series: string;
    singleVehicle: string;
  }